import React from 'react';
import tpl from '../templates/prostor';
import {apiback} from '../../../../config';
import CreditCardsModel from '../../models/creditCards.m';
import BaseNewCardView from '../../views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            tab: 'tariffs'
        };
    }

    componentDidMount() {
        super.componentDidMount();

        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new CreditCardsModel(json.data['green_card'])
                })
            )
            .catch(err => {
                console.error('[ProstorCard] Failed to load credit model:', err);
            });
    }

    static displayName = 'ProstorCard.Views.Main';
}
